<template>
  <div>
    <b-modal
      title="詳細帳單"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <tables-page
        :tableData="data"
        :tableFields="table_fields"
      >
        <template #cell(no)="row">
          {{ row.index + 1 }}
        </template>

        <template #cell(type)="row">
          <span :class="getBillTypeColor(row.item.type)">{{ getBillFeeDescription(row.item) }}</span>
        </template>

        <template #cell(dead_at)="row">
          {{ convertRocDate(row.item.dead_at) }}
        </template>
      </tables-page>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import { convertRocDate, getBillTypeColor, getBillFeeDescription } from "@/models/HELPERS/common.js";

export default {
  name: 'MutualListModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Array,
      required: true,
      default: []
    }
  },
  components: {
    TablesPage
  },
  data () {
    return {
      table_fields: [
        {
          key: "no",
          label: "No",
        },
        {
          key: "number",
          label: "契約編號",
        },
        {
          key: "member_name",
          label: "互助人姓名",
        },
        {
          key: "period",
          label: "期別",
        },
        {
          key: "type",
          label: "類型",
        },
        {
          key: "amount",
          label: "繳費金額",
        }
      ]
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    convertRocDate,
    getBillTypeColor,
    getBillFeeDescription
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/Modal/DetailBillModal.vue